/**
 * StreamWatchTimer — Compact elapsed-time indicator for stream theaters.
 *
 * Shows "MM:SS" (or "H:MM:SS" for 1hr+) with a recording dot to signal
 * that watch time is being tracked across the platform — quests, competitions,
 * objectives, brand activations, achievements, streaks.
 */

import "./StreamWatchTimer.scss";

interface StreamWatchTimerProps {
    elapsedSeconds: number;
}

function formatElapsed(totalSeconds: number): string {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    const seconds = totalSeconds % 60;

    const mm = String(minutes).padStart(2, "0");
    const ss = String(seconds).padStart(2, "0");

    if (hours > 0) {
        return `${hours}:${mm}:${ss}`;
    }
    return `${mm}:${ss}`;
}

export const StreamWatchTimer = ({ elapsedSeconds }: StreamWatchTimerProps) => {
    if (elapsedSeconds <= 0) return null;

    return (
        <span className="stream-watch-timer">
            <span className="stream-watch-timer__dot" />
            <span className="stream-watch-timer__time">{formatElapsed(elapsedSeconds)}</span>
        </span>
    );
};
